// Recovered compiled webpack factory 5917. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { A: () => a });
  let a = (0, r(19904).A)("check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
}
